export const maskToken = (accessToken: string): string => {
  if (accessToken.length <= 4) {
    return accessToken
  }

  const lastFour = accessToken.slice(-4)

  return `••••${lastFour}`
}
